module.exports = __webpack_public_path__ + "static/media/Section 7 - Person.cf9bf029.svg";